import React, { useState, useEffect } from 'react';
import {useHistory, useParams} from 'react-router-dom';
import GuestBar from "../../components/GuestInfo/GuestBar";
import {
  Breadcrumbs,
  Button,
  Container,
  FormControlLabel,
  Paper,
  Radio,
  RadioGroup,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import {
  getNextStep,
  getPreviousStep,
  getStepFromUrl, registerBookingTrip,
  requestApi,
  restartBooking,
  showAlertAutoDis, validateForm
} from "../../utils/utils";
import {useDispatch, useSelector} from "react-redux";
import Grid from "@mui/material/Grid";
import {setStep} from "../../redux/actions/stepActions";
import Itinerary from "../../components/Booking/DayTripBooking/Itinerary";
import ActivityBookingReview from "../../components/Booking/DayTripBooking/ActivityBookingReview";
import DayTripStepper from "../../components/Booking/DayTripBooking/DayTripStepper";
import {useAuthUser, useIsAuthenticated} from "react-auth-kit";
import {loadStripe} from "@stripe/stripe-js/pure";
import {getTripById} from "../../redux/actions/tripActions";
import * as yup from "yup";
import {Elements} from "@stripe/react-stripe-js";
import ParkFeeCheckoutForm from "../../components/Booking/Payment/ParkFeeCheckoutForm";
import {makeStyles} from "@mui/styles";
import {getActivityList} from "../../redux/actions/activitiesActions";
import {SET_SELECTED_EXTRAS} from "../../redux/constants/transactionConstants";
import {setTotalActivitiesFH} from "../../redux/actions/totalActions";
import Summary from "../../components/Booking/DayTripBooking/Summary";

let billingDetailsValidation = yup.object().shape({
  country: yup.string().required('The country is required'),
  state: yup.string().required('The state is required'),
  address_city: yup.string().required('The city is required'),
  address_line1: yup.string().required('The address is required'),
  address_zip: yup.string().required('The Zip code is required'),
  name: yup.string().required('The Name is required'),
  email: yup.string().required('The Email is required'),
});
const useStyles = makeStyles((theme) => ({
  cellsPayment: {
    fontSize: '1.4rem !important',
    verticalAlign: 'middle !important'
  },
  form: {
    marginTop: '30px',
    display: 'flex',
    gap: '10px',
    justifyContent: 'space-between',
    "@media (max-width: 600px)": {
      flexDirection: 'column',
    }
  },
  fileTextWrapper: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: 'flex',
    alignItems: 'center',
    padding: '5px 10px',
    flex: '1 1 auto',
  },
  errorText: {
    position: 'absolute',
    bottom: '-15px',
    left: 0,
    color: 'red'
  },
}));
const DayTripsPaymentPage = ({history}) => {
  const {bookingId} = useParams();
  const dispatch = useDispatch();
  const step = useSelector(state => state.step);
  const [booking, setBooking] = useState({})
  const [payThisMuch, setPayThisMuch] = useState(0.0);
  const classes = useStyles();
  const [stripePromise, setStripePromise] = useState(false);
  const [billingDetails, setBillingDetails] = useState({
    country: '',
    state: '',
    address_city: '',
    address_line1: '',
    address_line2: '',
    address_zip: '',
    email: '',
    name: ''
  });
  const {stripeKey} = window;
  const user = useAuthUser();
  const prefixUrl = 'booking/day-trips';
  const historyUrl = useHistory();
  const [currentPrice, setCurrentPrice] = useState(0.0);

  useEffect(()=>{
    dispatch(getActivityList()).then(()=>{
      const storedTransactions = sessionStorage.getItem('transactions');
      if (storedTransactions) {
        const parsed = JSON.parse(storedTransactions);
        dispatch({
          type: SET_SELECTED_EXTRAS,
          payload: parsed.extra || {}
        });
        dispatch(setTotalActivitiesFH());
      }
    })
  },[])

  useEffect(() => {
    const stepNum = getStepFromUrl(history.location.pathname);
    dispatch(setStep(stepNum));
    setStripePromise(loadStripe(stripeKey));
  }, []);
  const  calculateLeftToPay=(data) =>{
    const leftToPay =  parseFloat(data.DealerPrice) - parseFloat(data.TotalPaid);
    setCurrentPrice(leftToPay > 0 ? leftToPay : 0);
  }

  const setEmailAndName = () => {
    const name = user().firstName + ' ' + user().lastName || '';
    const email = user().email || '';
    setBillingDetails({...billingDetails, email, name});
  };
  const setDetails = (event) => {
    setBillingDetails({...billingDetails, [event.target.name]: event.target.value});
  };
  const sendStripeToken = async (token) => {
    if (!await validateForm(billingDetailsValidation, billingDetails, 'Billing Details Form')) return;
    const paymentData = {
      amount: payThisMuch,
      billingDetails
    };

    const {
      name,
      brand,
      address_line1,
      address_city,
      address_zip,
      cvc_check,
      address_zip_check,
      country,
      last4
    } = token.card;

    paymentData.cardInfo = {
      name,
      brand,
      address_line1,
      address_city,
      address_zip,
      cvc_check,
      address_zip_check,
      country,
      last4
    };

    paymentData.token = token.id
    paymentData.created = token.created;

    const url = `/activities/booking/payment/${bookingId}`;
    const {data} = await requestApi(url, 'POST', paymentData);
    let successPayment = false;

    if ('status' in data && data['status'] === 'success') {
      successPayment = !!data?.successPayment;
      if (successPayment)
        showAlertAutoDis({title: 'Success', text: 'Payment successful', manualClose: true}, () => {
          //Todo: Refresh the table with the payments
          goToConfirmation();
        });
    } else if ('message' in data)
      showAlertAutoDis({title: 'Error', text: data['message']});
  };

  async function getBooking() {
    const {data} = await requestApi(`/activities/booking/get/${bookingId}`);
    if ('status' in data && data['status'] === 'success') {
      if (Object.keys(data['booking']).length > 0) {
        setBooking(data['booking']);
      }
      if (Object.keys(data['transactions']).length > 0)
        sessionStorage.setItem('transactions', JSON.stringify(data['transactions']));
      calculateLeftToPay(data['booking'])
    }
  }
  useEffect(() => {
    const stepNum = getStepFromUrl(history.location.pathname);
    dispatch(setStep(stepNum));
    setStripePromise(loadStripe(stripeKey));
    setEmailAndName();
    if (Object.keys(booking).length === 0)
      getBooking().catch();
  }, []);

  const goBack = () => {
    const prevStep = getPreviousStep(step);
      historyUrl.push(`/${prefixUrl}${prevStep.url}`);
  };

  const handlerPayThis = () => {
    setPayThisMuch(parseFloat(currentPrice));
  };

  const goToConfirmation = () => {
    let url = `/${prefixUrl}/${bookingId}/confirmation`;
    return historyUrl.push(url);
  };
  const sendFlywireToken = async (token) => {
    const paymentData = {
      amount: payThisMuch,
      billingDetails: {
        name: billingDetails['name'],
        email: billingDetails['email'],
      }
    };
    const {
      amount,
      amountCurrency,
      digits,
      expirationMonth,
      expirationYear,
      payerAmount,
      payerAmountCurrency,
      paymentMethod,
      reference,
      sig,
      status,
    } = token;
    paymentData.cardInfo = {
      amount,
      amountCurrency,
      digits,
      expirationMonth,
      expirationYear,
      payerAmount,
      payerAmountCurrency,
      paymentMethod,
      reference,
      sig,
      status,
    };
    paymentData.token = token.token;


    await requestApi(`paymentFlywire/${bookingId}`, 'POST', paymentData, ({ data }) => {
      let successPayment = false;

      if ('status' in data && data['status'] === 'success') {
        successPayment = !!data['successPayment'];
        if (successPayment)
          goToConfirmation();
      } else if ('message' in data)
        showAlertAutoDis({ title: 'Error', text: data['message'] });
    });
  };

  return (
      <>
        <GuestBar>
          <Breadcrumbs aria-label="breadcrumb" separator={'>'}>
            <Typography color="text.primary">Day Trip Bookings - Payment</Typography>
          </Breadcrumbs>
        </GuestBar>

        <Container maxWidth="lg">
          <DayTripStepper/>
          <div style={{marginTop: 50}}/>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={12} md={9}>
                  <Typography variant="body1">
                    Icarus Aviation dba Nautilus Explorer - Nautilus Liveaboards, Nautilus Dive Adventures, a Canadian company
                    Please note that while this transaction will be processed in US dollars via our U.S. Bank account, some clients' bank/credit card companies have charged a "foreign transaction fee" because we are a Canadian company.
                  </Typography>
                  <Typography variant="body1" style={{ marginTop: '30px' }}>
                    All transactions are made in US Dollars. We accept Visa, Mastercard, and American Express.
                  </Typography>
                  <Grid item xs>
                    <div className="center" style={{marginTop: '50px'}}>
                      <img src={`${window['appBasename']}/images/payment-methods.jpg`}
                           alt="Mastercard, Visa, American Express"
                           style={{height: 50, width: 233, margin: '1.5rem auto'}}/>
                    </div>
                  </Grid>
                  {currentPrice>0 ? <Grid item xs>
                    <RadioGroup sx={{margin: '0 auto', maxWidth: '470px'}} aria-label="pay-options" name={'payThisMuch'}
                                onChange={handlerPayThis}>
                      <Table sx={{boxShadow: 'none'}} aria-label="simple table">
                        <TableHead>
                          <TableRow>
                            <TableCell className={classes.cellsPayment} align="center">Payment</TableCell>
                            <TableCell className={classes.cellsPayment} align="center">Amount</TableCell>
                            <TableCell/>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          <TableRow>
                            <TableCell className={classes.cellsPayment} align="center"><strong>Activities
                              Amount</strong></TableCell>
                            <TableCell className={classes.cellsPayment} align="center" style={{whiteSpace: 'nowrap'}}
                            >$ {currentPrice.formatMoney()}</TableCell>
                            <TableCell className={classes.cellsPayment}>
                              <FormControlLabel
                                  className={'cleanCheckbox'}
                                  value={currentPrice}
                                  control={<Radio color="primary"/>}
                                  label={`Pay this`}/>
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </RadioGroup>
                    {payThisMuch > 0 && <div style={{marginTop: 30}}>
                      <Typography align={'center'} id="transition-modal-title" variant={'h3'}>
                        Pay Now $ {payThisMuch.formatMoney()} USD
                      </Typography>
                      {stripePromise && <Elements stripe={stripePromise}>
                        <ParkFeeCheckoutForm
                            setBilling={setDetails}
                            billingDetails={billingDetails}
                            sendStripeToken={sendStripeToken}/>
                      </Elements>}
                    </div>}
                  </Grid> :  <Typography align={'center'} id="transition-modal-title" variant={'h3'}>
                    No pending payments
                  </Typography>}
                </Grid>
                <Grid item xs={12} sm={12} md={3}>
                  <Paper style={{marginTop: 20}}>
                    <Button color={'primary'} variant={'contained'} fullWidth onClick={goToConfirmation}>
                      Go To Confirmation
                    </Button>
                    <Button color={'secondary'} variant={'contained'} fullWidth onClick={goBack}>
                      Go Back Summary
                    </Button>
                  </Paper>
                  <Itinerary removable={false}/>
                  <Summary/>
                </Grid>
              </Grid>
        </Container>
      </>
  );
};

export default DayTripsPaymentPage;
